// ─── 🧾 Il campo da pagare, nella scheda (19/10/2026) ───────────────────────
//
// Dal mockup «Giocatori non trovati», approvato: un'ora prima, chi ha
// organizzato una partita aperta e non piena la disdice dal bot, e il campo
// intero lo paga lui. Gli altri non pagano niente. Qui la Segreteria vede chi
// deve e quanto, e quando ha incassato tocca «Segna pagato».

import { formatCents, type SchedaPrenotazione } from '@pmo/shared';
import { SegnaPagato } from '../cassa/SegnaPagato.js';

export function CampoDaPagare({
  p,
  puoIncassare,
}: {
  p: SchedaPrenotazione;
  puoIncassare: boolean;
}): React.JSX.Element | null {
  const c = p.courtDue;
  if (!c) return null;
  const chi = c.memberName ?? 'chi l’ha organizzata';
  // ⚖️ Senza cifra il listino non la diceva: la decide la Segreteria, e lo si scrive.
  const quanto = c.cents === null ? 'la cifra la decide la Segreteria' : formatCents(c.cents);

  return (
    <div className="caparra-scheda">
      {c.paidAt !== null ? (
        <p>
          ✓ Campo pagato il {new Date(c.paidAt).toLocaleDateString('it-IT', { timeZone: 'Europe/Rome' })}:{' '}
          <strong>{chi}</strong> {quanto}.
        </p>
      ) : (
        <>
          <p>
            Campo da pagare: <strong>{chi}</strong> {quanto}
          </p>
          {puoIncassare && c.memberId !== null && <SegnaPagato bookingId={p.id} cents={c.cents} chi={chi} />}
        </>
      )}
    </div>
  );
}
